import LogoVipFr from '../../src/legacy/LogoVipFr';
export default LogoVipFr;
